/* Ingram 1949 - galleria prodotto su mobile: frecce precedente/successiva.   17/09
 *
 * Horizon disegna le frecce della galleria solo con la presentazione
 * «carosello», e sempre con `mobile:hidden`
 * (snippets/product-media-gallery-content.liquid). Con la griglia su desktop,
 * sotto i 750px resta il carosello di serie con i soli pallini. Qui si
 * aggiungono due pulsanti che chiamano i metodi del componente di serie
 * (`slideshow-component.previous()` / `.next()`): scorrimento, pallini e zoom
 * restano quelli di Horizon. Sopra i 750px i pulsanti sono nascosti via CSS
 * (assets/ingram-ritocchi.css). */
(() => {
  const ICONA = {
    previous: '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12.5 4 6.5 10l6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    next: '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m7.5 4 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
  };
  const ETICHETTA = { previous: 'Foto precedente', next: 'Foto successiva' };

  const monta = (galleria) => {
    const show = galleria.querySelector('slideshow-component');
    if (!show || show.querySelectorAll('slideshow-slide').length < 2) return;
    if (show.querySelector('.ingram-galleria__freccia')) return;
    const contenitore = show.querySelector('slideshow-container') || show;
    for (const azione of ['previous', 'next']) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `ingram-galleria__freccia ingram-galleria__freccia--${azione}`;
      b.setAttribute('aria-label', ETICHETTA[azione]);
      b.innerHTML = ICONA[azione];
      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof show[azione] === 'function') show[azione]();
      });
      contenitore.appendChild(b);
    }
  };

  const tutte = () => document.querySelectorAll('media-gallery').forEach(monta);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  // La galleria viene ridisegnata al cambio di variante.
  new MutationObserver(tutte).observe(document.documentElement, { childList: true, subtree: true });
})();